import * as React from 'react';
export const GridContext = React.createContext({
    element: 'div',
});
const Grid = (props) => {
    const { align, borderColor, borderWeight, children, className, equalHeight, element: Element = 'div', gridRef, gutter = 'default', horizontalGutter, id, noWrap, onTransitionEnd, reverse, style, verticalGutter, wrap, } = props;
    const BEM = () => {
        const classArray = ['grid', `grid--gutter-${gutter}`];
        if (equalHeight) {
            classArray.push('grid--equalheight');
        }
        if (reverse) {
            for (const i of reverse) {
                classArray.push(`grid--reverse-${i}`);
            }
        }
        if (align) {
            for (const i of align) {
                classArray.push(`grid--${i}`);
            }
        }
        if (horizontalGutter) {
            classArray.push(`grid--horizontal-gutter-${horizontalGutter}`);
        }
        if (verticalGutter) {
            classArray.push(`grid--vertical-gutter-${verticalGutter}`);
        }
        if (noWrap) {
            if (Array.isArray(noWrap)) {
                for (const i of noWrap) {
                    classArray.push(`grid--no-wrap-${i}`);
                }
            }
            else {
                classArray.push('grid--no-wrap-xs');
            }
        }
        if (wrap) {
            for (const i of wrap) {
                classArray.push(`grid--wrap-${i}`);
            }
        }
        if (borderWeight) {
            classArray.push(`grid--border-${borderWeight}`);
        }
        if (borderColor) {
            classArray.push(`grid--border-${borderColor}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const content = (React.createElement(GridContext.Provider, { value: { element: Element } }, children));
    if (Element === 'ul') {
        return (React.createElement(Element, { id: id, className: BEM(), style: style, onTransitionEnd: onTransitionEnd, ref: gridRef }, content));
    }
    if (Element === 'ol') {
        return (React.createElement(Element, { id: id, className: BEM(), style: style, onTransitionEnd: onTransitionEnd, ref: gridRef }, content));
    }
    return (React.createElement(Element, { id: id, className: BEM(), style: style, onTransitionEnd: onTransitionEnd, ref: gridRef }, content));
};
export default Grid;
